import { useAffiliateRegConfig } from '@/modules/promo';
import { useIsSports } from '@/modules/sports/hooks';
import { useGetCommonStore } from '@/store';
import { REGISTRATION_CONFIGS } from '../helpers';

export const useRegModalTheme = () => {
  const useCommonStore = useGetCommonStore();
  const { regModalTheme } = useAffiliateRegConfig();

  const isSports = useIsSports();

  const registrationTheme = isSports
    ? 'darkSports'
    : regModalTheme || useCommonStore.use.registrationTheme();

  return (
    REGISTRATION_CONFIGS[registrationTheme] || REGISTRATION_CONFIGS.default
  );
};
